import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const upsertClaim = async (dto) => {
  const { data } = await axiosConsumer.post("/", dto);
  return data;
};

export const getClaim = async (claimId: string) => {
  const { data } = await axiosConsumer.get(`/${claimId}`);
  return data;
};

export const createDeskTicket = async (dto) => {
  const { data } = await axiosConsumer.post(`/desk-ticket`, dto);
  return data;
};

export const getPresignedURL = async (claimId: string, fileType: string) => {
  const { data } = await axiosConsumer.get(
    `/${claimId}/file-upload-url?fileType=${fileType}`
  );
  return data;
};

export const deleteClaimImage = async (claimId: string, fileName: string) => {
  const { data } = await axiosConsumer.delete(`/${claimId}/file/${fileName}`);
  return data;
};
